import { notification } from 'antd'
import {getRelationCdiResumeService} from '../services/getRelationCdiResumeService'

export const getRelationCdiResumePromise= () => {
	return new Promise(resolve => {
		getRelationCdiResumeService()
			.then(response => resolve({ success: true, data: response.data }))
			.catch(error => {notification.error({message: "Alert Resume : "+error.message})})
	})
}

